import { daysLeftLabel } from './formatDate';
import type { CompanySubscriptionResponse } from './types';

/** The one human-readable status label for a subscription, derived ONLY from the server's `effectiveState`
 * (never from the persisted `status`, which can still read "Trialing" for an expired trial). The text always
 * carries the meaning; the badge colour is reinforcement only. */
export function subscriptionStatusLabel(subscription: CompanySubscriptionResponse): string {
  switch (subscription.effectiveState) {
    case 'TrialActive': {
      const left = daysLeftLabel(subscription.trialDaysRemaining);
      return left ? `Trial Active — ${left}` : 'Trial Active';
    }
    case 'TrialNotStarted': return 'Plan Selected — Trial Not Started';
    case 'TrialExpired': return 'Trial Expired';
    case 'Active': return 'Active';
    case 'PendingChange': return 'Plan Change Pending';
    case 'PastDueGrace': return 'Payment Failed — Access Continues';
    case 'PastDueRestricted': return 'Payment Failed — Read-Only';
    case 'Canceled': return 'Canceled';
    default: return subscription.status;
  }
}

export function subscriptionStatusBadgeClass(subscription: CompanySubscriptionResponse): string {
  switch (subscription.effectiveState) {
    case 'TrialActive':
    case 'TrialNotStarted':
    case 'PastDueGrace': return 'badge badge--warning';
    case 'TrialExpired':
    case 'PastDueRestricted':
    case 'Canceled': return 'badge badge--blocked';
    default: return 'success';
  }
}
